import { useDictionaryContext } from '3-foundation/Dictionary/DictionaryContext';
import { UI_RichText } from 'ui/components/1-atoms/RichText/RichText';
import { UI_Tabs } from 'ui/components/3-organisms/Tabs/Tabs';
import { UI_Container } from 'ui/components/4-habitats/Container/Container';

export const ContactOffices = ({ contactOffices }: { contactOffices: Site.Office[] }) => {
	const dictionary = useDictionaryContext();
	return null;
	return contactOffices?.map((office, index) => {
		return (
			<>
				<UI_Container width="Standard">
					<UI_RichText key={index} content={office.contactdatahtml} />
				</UI_Container>
				{office.settlements?.length > 0 && (
					<UI_Tabs
						tabsTitle={dictionary.getContact('ChooseYourCity')}
						removeTopSpacing
						tabs={office.settlements?.map((settlement) => ({
							title: settlement.name,
							id: settlement.id,
							content: <UI_RichText content={settlement.contactdatahtml} />,
						}))}
						width="Standard"
					/>
				)}
			</>
		);
	});
};
